import Validator from 'validatorjs';
import { t, lang } from 'helpers/i18n';
// Load required languages (en loaded by default)
// Validator.setMessages('es', require('validatorjs/src/lang/es'))
Validator.useLang(lang);
Validator.setAttributeFormatter(function (attribute) { return t(attribute.replace(/.+\./, '')); });
var regxAlphaDashSpace = /^[a-zA-Z0-9_:\- ]+[a-zA-Z0-9_\-]$/;
Validator.register('alpha_dash_space', function (value) { return regxAlphaDashSpace.test(value); }, t('alpha_dash_space'));
Validator.register('array_emails_comma', function (value) {
    var emails = value.split(',');
    var rule = new Rules();
    var result = true;
    var i = 0;
    while (i < emails.length && result) {
        var toCheck = emails[i].replace(/\s+/g, '');
        // \s+ regex para uno o más espcios en blanco
        // regex g para flag global significa todos \s (espacios en blanco)
        result = checkEmail(toCheck);
        i++;
    }
    return result;
}, t('error_array_emails_comma'));
Validator.register('major_another_field', function (value, requirement, attribute) {
    // esta regla es para validar si el valor de un campo es mayor al valor
    // que tiene otro campo que se pasa por parámetro
    var splited = requirement.split(',');
    var fieldToValidate = splited[0];
    // @ts-ignore
    var valueToCompare = this.validator.input[fieldToValidate];
    if (valueToCompare === undefined) {
        // no se ha asignado valor al campo para la validación, no queremos validar
        return true;
    }
    if (Number(valueToCompare)) {
        var _value = Number(value);
        if (_value < valueToCompare) {
            return false;
        }
    }
    return true;
}, "the :attribute tiene que ser mayor que :fieldReferenced", function (template, rule) {
    var parameters = rule.getParameters();
    // @ts-ignore
    return this._replacePlaceholders(rule, template, {
        attribute: parameters[0],
        fieldReferenced: parameters[2] ? parameters[2] : parameters[1]
    });
});
Validator.register('minor_another_field', function (value, requirement, attribute) {
    // esta regla es para validar si el valor de un campo es menor al valor
    // que tiene otro campo que se pasa por parámetro
    var splited = requirement.split(',');
    var fieldToValidate = splited[0];
    // @ts-ignore
    var valueToCompare = this.validator.input[fieldToValidate];
    if (valueToCompare === undefined) {
        // no se ha asignado valor al campo para la validación, no queremos validar
        return true;
    }
    if (Number(valueToCompare)) {
        var _value = Number(value);
        if (_value > valueToCompare) {
            return false;
        }
    }
    return true;
}, "the :attribute tiene que ser menor que :fieldReferenced", function (template, rule) {
    var parameters = rule.getParameters();
    // @ts-ignore
    return this._replacePlaceholders(rule, template, {
        attribute: parameters[0],
        fieldReferenced: parameters[2] ? parameters[2] : parameters[1]
    });
});
var checkEmail = function (val) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(val)) {
        // added support domain 3-n level https://github.com/skaterdav85/validatorjs/issues/384
        re = /^((?:[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]|[^\u0000-\u007F])+@(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?(?:\.(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?)+)*$/;
    }
    return re.test(val);
};
var Validation = /** @class */ (function () {
    function Validation(values, schema) {
        this.validator = new Validator(values, this.parseSchema(schema));
    }
    Object.defineProperty(Validation.prototype, "valid", {
        get: function () {
            return this.validator.passes();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Validation.prototype, "errors", {
        get: function () {
            return this.validator.errors.all();
        },
        enumerable: false,
        configurable: true
    });
    Validation.prototype.parseSchema = function (schema) {
        return Object.keys(schema).reduce(function (newSchema, key) {
            if (schema[key])
                newSchema[key] = schema[key].result;
            return newSchema;
        }, {});
    };
    return Validation;
}());
export { Validation };
var Rules = /** @class */ (function () {
    function Rules() {
        this._rules = [];
    }
    Object.defineProperty(Rules.prototype, "result", {
        get: function () {
            return this._rules.join('|');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rules.prototype, "isRequired", {
        get: function () {
            return this._rules.indexOf('required') > -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rules.prototype, "rules", {
        set: function (value) {
            this._rules.push(value);
        },
        enumerable: false,
        configurable: true
    });
    Rules.prototype.accepted = function () {
        this.rules = 'accepted';
        return this;
    };
    Rules.prototype.after = function (date) {
        this.rules = "after:".concat(date);
        return this;
    };
    Rules.prototype.afterOrEqual = function (date) {
        this.rules = "after_or_equal:date:".concat(date);
        return this;
    };
    Rules.prototype.alpha = function () {
        this.rules = 'alpha';
        return this;
    };
    Rules.prototype.alphaDash = function () {
        this.rules = 'alpha_dash';
        return this;
    };
    Rules.prototype.alphaDashSpace = function () {
        this.rules = 'alpha_dash_space';
        return this;
    };
    Rules.prototype.array = function () {
        this.rules = 'array';
        return this;
    };
    Rules.prototype.arrayEmailsComma = function () {
        this.rules = 'array_emails_comma';
        return this;
    };
    Rules.prototype.majorAnotherField = function (field, translateField) {
        this.rules = "major_another_field:".concat(field, ",").concat(translateField);
        return this;
    };
    Rules.prototype.minorAnotherField = function (field, translateField) {
        this.rules = "minor_another_field:".concat(field, ",").concat(translateField);
        return this;
    };
    Rules.prototype.before = function (date) {
        this.rules = "before:".concat(date);
        return this;
    };
    Rules.prototype.beforeOrEqual = function (date) {
        this.rules = "before_or_equal:date:".concat(date);
        return this;
    };
    Rules.prototype.between = function (min, max) {
        this.rules = "between:".concat(min, ",").concat(max);
        return this;
    };
    Rules.prototype.boolean = function () {
        this.rules = 'boolean';
        return this;
    };
    Rules.prototype.confirmed = function () {
        this.rules = 'confirmed';
        return this;
    };
    Rules.prototype.date = function () {
        this.rules = 'date';
        return this;
    };
    Rules.prototype.digits = function (value) {
        this.rules = "digits:".concat(value);
        return this;
    };
    Rules.prototype.different = function (field) {
        this.rules = "different:".concat(field);
        return this;
    };
    Rules.prototype.email = function () {
        this.rules = 'email';
        return this;
    };
    Rules.prototype.in = function (array) {
        this.rules = "in:".concat(array);
        return this;
    };
    Rules.prototype.integer = function () {
        this.rules = 'integer';
        return this;
    };
    Rules.prototype.max = function (value) {
        this.rules = "max:".concat(value);
        return this;
    };
    Rules.prototype.min = function (value) {
        this.rules = "min:".concat(value);
        return this;
    };
    Rules.prototype.notIn = function (array) {
        this.rules = "not_in:".concat(array);
        return this;
    };
    Rules.prototype.number = function () {
        this.rules = 'numeric';
        return this;
    };
    Rules.prototype.object = function () {
        this.rules = 'object';
        return this;
    };
    Rules.prototype.required = function () {
        this.rules = 'required';
        return this;
    };
    Rules.prototype.requiredIf = function (anotherfield, value) {
        this.rules = "required_if:".concat(anotherfield, ",").concat(value);
        return this;
    };
    Rules.prototype.requiredUnless = function (anotherfield, value) {
        this.rules = "required_unless:".concat(anotherfield, ",").concat(value);
        return this;
    };
    Rules.prototype.requiredWith = function (anotherfields) {
        this.rules = "required_with:".concat(anotherfields);
        return this;
    };
    Rules.prototype.requiredWithAll = function (anotherfields) {
        this.rules = "required_with_all:".concat(anotherfields);
        return this;
    };
    Rules.prototype.requiredWithout = function (anotherfields) {
        this.rules = "required_without:".concat(anotherfields);
        return this;
    };
    Rules.prototype.requiredWithoutAll = function (anotherfields) {
        this.rules = "required_without_all:".concat(anotherfields);
        return this;
    };
    Rules.prototype.same = function (field) {
        this.rules = "same:".concat(field);
        return this;
    };
    Rules.prototype.size = function (value) {
        this.rules = "size:".concat(value);
        return this;
    };
    Rules.prototype.string = function () {
        this.rules = 'string';
        return this;
    };
    Rules.prototype.url = function () {
        this.rules = 'url';
        return this;
    };
    Rules.prototype.empty = function () {
        this.rules = "regex:^$";
        return this;
    };
    Rules.prototype.regex = function (pattern) {
        this.rules = "regex:".concat(pattern);
        return this;
    };
    return Rules;
}());
export { Rules };
export var rules = function () { return new Rules(); };



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Validation.ts
// module id = 29
// module chunks = 0